import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface AdminItemTypeDto {
	id: string;
	name: string;
	description: string | null;
	category: string | null;
	isConsumable: boolean;
	isMagical: boolean;
	slot: string | null;
	colorToken: string | null;
	imageAssetId: string | null;
	createdAt: string;
	updatedAt: string;
}

export interface AdminItemTypesListResponse {
	itemTypes: AdminItemTypeDto[];
}

export interface AdminItemTypeGetResponse {
	itemType: AdminItemTypeDto;
}

export interface AdminItemTypeCreateRequest {
	id?: string | null;
	name: string;
	description?: string | null;
	category?: string | null;
	isConsumable?: boolean;
	isMagical?: boolean;
	slot?: string | null;
	colorToken?: string | null;
	imageAssetId?: string | null;
}

export interface AdminItemTypeUpdateRequest {
	name?: string | null;
	description?: string | null;
	category?: string | null;
	isConsumable?: boolean | null;
	isMagical?: boolean | null;
	slot?: string | null;
	colorToken?: string | null;
	imageAssetId?: string | null;
}

@Injectable({ providedIn: 'root' })
export class AdminItemTypesService {
	constructor(private readonly http: HttpClient) {}

	list(): Observable<AdminItemTypesListResponse> {
		return this.http.get<AdminItemTypesListResponse>(`${environment.api.baseUrl}/v1/admin/item-types`);
	}

	get(id: string): Observable<AdminItemTypeGetResponse> {
		return this.http.get<AdminItemTypeGetResponse>(`${environment.api.baseUrl}/v1/admin/item-types/${id}`);
	}

	create(request: AdminItemTypeCreateRequest): Observable<AdminItemTypeGetResponse> {
		return this.http.post<AdminItemTypeGetResponse>(`${environment.api.baseUrl}/v1/admin/item-types`, request);
	}

	update(id: string, request: AdminItemTypeUpdateRequest): Observable<AdminItemTypeGetResponse> {
		return this.http.put<AdminItemTypeGetResponse>(`${environment.api.baseUrl}/v1/admin/item-types/${id}`, request);
	}

	delete(id: string): Observable<void> {
		return this.http.delete<void>(`${environment.api.baseUrl}/v1/admin/item-types/${id}`);
	}
}
